(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ing-slider')) {
    class IngSlider extends HTMLElement {
      #track = null;
      #prev = null;
      #next = null;
      #thumb = null;
      #frame = 0;
      #observer = null;
      #onScroll = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#update());
      };
      #onPrev = () => this.#go(-1);
      #onNext = () => this.#go(1);

      connectedCallback() {
        this.#track = this.querySelector('[data-ing-track]');
        if (!this.#track) return;
        this.#prev = this.querySelector('[data-ing-prev]');
        this.#next = this.querySelector('[data-ing-next]');
        this.#thumb = this.querySelector('[data-ing-thumb]');
        this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
        this.#prev?.addEventListener('click', this.#onPrev);
        this.#next?.addEventListener('click', this.#onNext);
        this.#observer = new ResizeObserver(this.#onScroll);
        this.#observer.observe(this.#track);
        this.#update();
      }

      disconnectedCallback() {
        this.#track?.removeEventListener('scroll', this.#onScroll);
        this.#prev?.removeEventListener('click', this.#onPrev);
        this.#next?.removeEventListener('click', this.#onNext);
        this.#observer?.disconnect();
        cancelAnimationFrame(this.#frame);
      }

      #isRtl() {
        return getComputedStyle(this.#track).direction === 'rtl';
      }

      #update() {
        const track = this.#track;
        const max = track.scrollWidth - track.clientWidth;
        const scrollable = max > 2;
        this.toggleAttribute('data-scrollable', scrollable);
        if (!scrollable) return;
        const pos = Math.abs(track.scrollLeft);
        if (this.#prev) this.#prev.disabled = pos <= 2;
        if (this.#next) this.#next.disabled = pos >= max - 2;
        if (!this.#thumb) return;
        const ratio = track.clientWidth / track.scrollWidth;
        const travel = ((1 - ratio) / ratio) * 100;
        const dir = this.#isRtl() ? -1 : 1;
        this.#thumb.style.width = `${ratio * 100}%`;
        this.#thumb.style.transform = `translateX(${(pos / max) * travel * dir}%)`;
      }

      #go(dir) {
        const slide = this.#track.querySelector('[data-ing-slide]');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.#track).columnGap) || 0;
        const step = slide.getBoundingClientRect().width + gap;
        const perView = Math.max(1, Math.floor((this.#track.clientWidth + gap) / step));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#track.scrollBy({
          left: dir * step * perView * (this.#isRtl() ? -1 : 1),
          behavior: reduce ? 'auto' : 'smooth',
        });
      }
    }
    customElements.define('ing-slider', IngSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('journey-timeline')) {
    class JourneyTimeline extends HTMLElement {
      #stages = [];
      #fill = null;
      #observer = null;
      #frame = 0;
      #onScroll = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#updateFill());
      };

      connectedCallback() {
        this.#stages = [...this.querySelectorAll('[data-jr-stage]')];
        this.#fill = this.querySelector('[data-jr-fill]');

        if (!('IntersectionObserver' in window)) {
          this.#stages.forEach((s) => s.classList.add('is-active'));
          this.#fill?.style.setProperty('--jr-progress', '100%');
          return;
        }

        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) entry.target.classList.add('is-active');
            }
          },
          { rootMargin: '0px 0px -28% 0px', threshold: 0.2 }
        );
        this.#stages.forEach((s) => this.#observer.observe(s));

        window.addEventListener('scroll', this.#onScroll, { passive: true });
        window.addEventListener('resize', this.#onScroll, { passive: true });
        this.#updateFill();
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        window.removeEventListener('scroll', this.#onScroll);
        window.removeEventListener('resize', this.#onScroll);
        cancelAnimationFrame(this.#frame);
      }

      #updateFill() {
        if (!this.#fill) return;
        const rail = this.#fill.parentElement;
        const rect = rail.getBoundingClientRect();
        const anchor = window.innerHeight * 0.62;
        const progress = Math.min(1, Math.max(0, (anchor - rect.top) / rect.height));
        this.#fill.style.setProperty('--jr-progress', `${(progress * 100).toFixed(1)}%`);
      }
    }
    customElements.define('journey-timeline', JourneyTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-why-different"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('why-different')) {
    const VERT = `
      attribute vec2 a;
      void main() { gl_Position = vec4(a, 0.0, 1.0); }
    `;

    const FRAG = `
      precision highp float;
      uniform vec2 uRes;
      uniform vec3 uColor;
      uniform vec2 uSquash;
      uniform float uNeckLen;
      uniform float uNeckW;
      uniform vec3 uDrop;   /* x: y position, y: radius, z: flatten (0..1) */
      uniform float uRipple; /* 0..1 ripple progress, <0 = off */

      float sdEllipsoid(vec3 p, vec3 r) {
        float k0 = length(p / r);
        float k1 = length(p / (r * r));
        return k0 * (k0 - 1.0) / k1;
      }

      float smin(float a, float b, float k) {
        float h = clamp(0.5 + 0.5 * (b - a) / k, 0.0, 1.0);
        return mix(b, a, h) - k * h * (1.0 - h);
      }

      float map(vec3 p) {
        /* capsule body */
        vec3 bp = p - vec3(0.0, 0.55, 0.0);
        float body = sdEllipsoid(bp, vec3(0.62 * uSquash.x, 1.12 * uSquash.y, 0.62 * uSquash.x));

        /* forming drip (neck) hanging from the bottom */
        vec3 np = p - vec3(0.0, -0.5 - uNeckLen * 0.5, 0.0);
        float neck = sdEllipsoid(np, vec3(0.2 * uNeckW, 0.22 + uNeckLen * 0.5, 0.2 * uNeckW));

        /* free drop */
        vec3 dp = p - vec3(0.0, uDrop.x, 0.0);
        float r = max(uDrop.y, 0.0001);
        float drop = sdEllipsoid(dp, vec3(r * (1.0 + uDrop.z * 1.6), r * (1.0 - uDrop.z * 0.7), r * (1.0 + uDrop.z * 1.6)));

        float d = smin(body, neck, 0.28);
        d = smin(d, drop, 0.14);

        /* landing ripple: thin flat ring on the floor */
        if (uRipple >= 0.0) {
          float rr = 0.15 + uRipple * 0.75;
          vec2 q = vec2(length(p.xz) - rr, p.y + 2.18);
          float ring = length(q) - 0.035 * (1.0 - uRipple);
          d = min(d, ring);
        }
        return d;
      }

      vec3 normal(vec3 p) {
        vec2 e = vec2(0.002, 0.0);
        return normalize(vec3(
          map(p + e.xyy) - map(p - e.xyy),
          map(p + e.yxy) - map(p - e.yxy),
          map(p + e.yyx) - map(p - e.yyx)));
      }

      void main() {
        vec2 uv = (gl_FragCoord.xy * 2.0 - uRes) / uRes.y;
        vec3 ro = vec3(0.0, -0.35, 5.2);
        vec3 rd = normalize(vec3(uv * 0.62, -1.0));

        float t = 0.0;
        float minD = 1e9;
        bool hit = false;
        for (int i = 0; i < 80; i++) {
          vec3 p = ro + rd * t;
          float d = map(p);
          minD = min(minD, d);
          if (d < 0.0015) { hit = true; break; }
          t += d * 0.9;
          if (t > 12.0) break;
        }

        if (!hit) {
          /* soft anti-aliased halo at the silhouette */
          float a = 1.0 - smoothstep(0.0, 0.012, minD);
          gl_FragColor = vec4(uColor * 0.6 * a, a);
          return;
        }

        vec3 p = ro + rd * t;
        vec3 n = normal(p);
        vec3 v = -rd;

        vec3 keyL = normalize(vec3(-0.6, 0.9, 0.8));
        vec3 rimL = normalize(vec3(0.8, -0.3, 0.6));

        float diff = max(dot(n, keyL), 0.0);
        float fres = pow(1.0 - max(dot(n, v), 0.0), 3.0);

        /* fake studio environment: bright top, warm floor bounce */
        float env = mix(0.35, 1.0, n.y * 0.5 + 0.5);

        vec3 deep = uColor * uColor * 0.9;       /* darker, more saturated core */
        vec3 base = mix(deep, uColor, 0.35 + 0.65 * diff);
        base *= env;

        /* glassy inner glow: light travelling through the gel */
        float thick = smoothstep(0.0, 1.0, 1.0 - fres);
        base += uColor * 0.35 * thick * (0.5 + 0.5 * n.y);

        /* highlights */
        vec3 h1 = normalize(keyL + v);
        float spec1 = pow(max(dot(n, h1), 0.0), 140.0);
        vec3 h2 = normalize(rimL + v);
        float spec2 = pow(max(dot(n, h2), 0.0), 60.0) * 0.35;
        float rim = fres * 0.55;

        vec3 col = base + vec3(1.0) * (spec1 * 1.1 + spec2) + uColor * rim + vec3(1.0) * rim * 0.25;

        /* subtle edge darkening for weight */
        col *= 1.0 - fres * 0.25;

        gl_FragColor = vec4(col, 1.0);
      }
    `;

    const easeIn = (x) => x * x * x;
    const easeOut = (x) => 1 - Math.pow(1 - x, 3);
    const easeInOut = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
    const lerp = (a, b, k) => a + (b - a) * k;
    const seg = (t, a, b) => Math.min(1, Math.max(0, (t - a) / (b - a)));

    function timeline(t) {
      /* t in 0..1 over one cycle */
      const neckGrow = easeInOut(seg(t, 0.14, 0.46));
      const detach = seg(t, 0.46, 0.52);
      const fall = seg(t, 0.52, 0.74);
      const splash = seg(t, 0.74, 0.84);
      const recover = easeOut(seg(t, 0.52, 0.72));

      let neckLen = neckGrow * 0.55;
      let neckW = 1.0;
      if (t >= 0.46) {
        neckW = lerp(1.0, 0.18, easeIn(detach));
        neckLen = lerp(0.55, 0.0, recover);
      }

      let dropR = 0.0;
      let dropY = -4.0;
      let flatten = 0.0;
      if (t >= 0.2 && t < 0.84) {
        dropR = lerp(0.05, 0.19, neckGrow);
        const hangY = -0.5 - neckLen - 0.26 - dropR;
        if (t < 0.52) {
          dropY = hangY;
        } else {
          const startY = -0.5 - 0.55 - 0.26 - 0.19;
          dropY = lerp(startY, -2.18 + dropR, easeIn(fall));
        }
        if (t >= 0.74) {
          flatten = easeOut(splash);
          dropR = lerp(0.19, 0.0, easeIn(splash));
          dropY = -2.18 + dropR * 0.5;
        }
      }

      /* body squash: tiny bulge while the drip forms, relax after it falls */
      let sx = 1.0, sy = 1.0;
      sx -= 0.012 * neckGrow;
      sy += 0.02 * neckGrow;
      const bounce = Math.sin(seg(t, 0.52, 0.66) * Math.PI) * (1 - recover);
      sx += 0.02 * bounce;
      sy -= 0.03 * bounce;

      const ripple = t >= 0.73 && t < 0.98 ? seg(t, 0.73, 0.98) : -1;

      return { neckLen, neckW, dropY, dropR, flatten, sx, sy, ripple };
    }

    function hexToRgb(hex) {
      const h = hex.replace('#', '');
      const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
      return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
    }

    class WhyDifferent extends HTMLElement {
      #observer = null;
      #gl = null;
      #canvas = null;
      #uniforms = null;
      #raf = 0;
      #start = 0;
      #inview = false;
      #color = [0.91, 0.64, 0.09];
      #loop = true;
      #resize = null;

      connectedCallback() {
        this.#canvas = this.querySelector('[data-wd-canvas]');
        this.#loop = this.closest('.wd')?.classList.contains('wd--loop') ?? true;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.#canvas && !reduce) this.#initGL();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-inview');
          this.#setInview(true);
          return;
        }
        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              this.classList.toggle('is-inview', entry.isIntersecting);
              this.#setInview(entry.isIntersecting);
            }
          },
          { threshold: 0.2 }
        );
        this.#observer.observe(this);
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#resize?.disconnect();
        cancelAnimationFrame(this.#raf);
      }

      #initGL() {
        const gl = this.#canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false });
        if (!gl) return;

        const compile = (type, src) => {
          const sh = gl.createShader(type);
          gl.shaderSource(sh, src);
          gl.compileShader(sh);
          if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
            console.warn(gl.getShaderInfoLog(sh));
            return null;
          }
          return sh;
        };
        const vs = compile(gl.VERTEX_SHADER, VERT);
        const fs = compile(gl.FRAGMENT_SHADER, FRAG);
        if (!vs || !fs) return;

        const prog = gl.createProgram();
        gl.attachShader(prog, vs);
        gl.attachShader(prog, fs);
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
        gl.useProgram(prog);

        const buf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        const loc = gl.getAttribLocation(prog, 'a');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

        const u = (name) => gl.getUniformLocation(prog, name);
        this.#uniforms = {
          res: u('uRes'), color: u('uColor'), squash: u('uSquash'),
          neckLen: u('uNeckLen'), neckW: u('uNeckW'), drop: u('uDrop'), ripple: u('uRipple'),
        };

        const gelHex = getComputedStyle(this.closest('.wd')).getPropertyValue('--wd-gel').trim();
        if (gelHex.startsWith('#')) this.#color = hexToRgb(gelHex);

        gl.clearColor(0, 0, 0, 0);
        this.#gl = gl;
        this.classList.add('has-webgl');

        this.#resize = new ResizeObserver(() => this.#fit());
        this.#resize.observe(this.#canvas);
        this.#fit();
        this.#draw(0);
      }

      #fit() {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const rect = this.#canvas.getBoundingClientRect();
        const w = Math.max(2, Math.round(rect.width * dpr));
        const h = Math.max(4, Math.round(rect.height * dpr));
        if (this.#canvas.width !== w || this.#canvas.height !== h) {
          this.#canvas.width = w;
          this.#canvas.height = h;
          this.#gl.viewport(0, 0, w, h);
          if (!this.#inview) this.#draw(0);
        }
      }

      #setInview(v) {
        this.#inview = v;
        if (!this.#gl) return;
        if (v) {
          this.#start = performance.now();
          cancelAnimationFrame(this.#raf);
          this.#tick();
        } else {
          cancelAnimationFrame(this.#raf);
        }
      }

      #tick = () => {
        const elapsed = (performance.now() - this.#start) / 1000;
        const period = 4.2;
        let t = elapsed / period;
        if (!this.#loop && t >= 1) {
          this.#draw(0);
          return;
        }
        this.#draw(t % 1);
        this.#raf = requestAnimationFrame(this.#tick);
      };

      #draw(t) {
        const gl = this.#gl;
        if (!gl) return;
        const s = timeline(t);
        const u = this.#uniforms;
        gl.uniform2f(u.res, this.#canvas.width, this.#canvas.height);
        gl.uniform3f(u.color, this.#color[0], this.#color[1], this.#color[2]);
        gl.uniform2f(u.squash, s.sx, s.sy);
        gl.uniform1f(u.neckLen, s.neckLen);
        gl.uniform1f(u.neckW, s.neckW);
        gl.uniform3f(u.drop, s.dropY, s.dropR, s.flatten);
        gl.uniform1f(u.ripple, s.ripple);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }
    }
    customElements.define('why-different', WhyDifferent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pfc-slider')) {
    class PfcSlider extends HTMLElement {
      #track = null;
      #prev = null;
      #next = null;
      #thumb = null;
      #frame = 0;
      #observer = null;
      #onScroll = () => this.#schedule();
      #onPrev = () => this.#go(-1);
      #onNext = () => this.#go(1);

      connectedCallback() {
        this.#track = this.querySelector('[data-pfc-track]');
        if (!this.#track) return;

        this.#prev = this.querySelector('[data-pfc-prev]');
        this.#next = this.querySelector('[data-pfc-next]');
        this.#thumb = this.querySelector('[data-pfc-thumb]');

        this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
        this.#prev?.addEventListener('click', this.#onPrev);
        this.#next?.addEventListener('click', this.#onNext);

        this.#observer = new ResizeObserver(this.#onScroll);
        this.#observer.observe(this.#track);
        this.#update();
      }

      disconnectedCallback() {
        this.#track?.removeEventListener('scroll', this.#onScroll);
        this.#prev?.removeEventListener('click', this.#onPrev);
        this.#next?.removeEventListener('click', this.#onNext);
        this.#observer?.disconnect();
        cancelAnimationFrame(this.#frame);
      }

      #schedule() {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#update());
      }

      #isRtl() {
        return getComputedStyle(this.#track).direction === 'rtl';
      }

      #update() {
        const track = this.#track;
        const max = track.scrollWidth - track.clientWidth;
        const scrollable = max > 2;
        this.toggleAttribute('data-scrollable', scrollable);
        if (!scrollable) return;

        const pos = Math.abs(track.scrollLeft);
        if (this.#prev) this.#prev.disabled = pos <= 2;
        if (this.#next) this.#next.disabled = pos >= max - 2;

        if (!this.#thumb) return;
        const ratio = track.clientWidth / track.scrollWidth;
        const travel = ((1 - ratio) / ratio) * 100;
        const direction = this.#isRtl() ? -1 : 1;
        this.#thumb.style.width = `${ratio * 100}%`;
        this.#thumb.style.transform = `translateX(${(pos / max) * travel * direction}%)`;
      }

      #go(dir) {
        const slide = this.#track.querySelector('[data-pfc-slide]');
        if (!slide) return;

        const gap = parseFloat(getComputedStyle(this.#track).columnGap) || 0;
        const step = slide.getBoundingClientRect().width + gap;
        const perView = Math.max(1, Math.floor((this.#track.clientWidth + gap) / step));
        const direction = this.#isRtl() ? -1 : 1;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.#track.scrollBy({
          left: dir * step * perView * direction,
          behavior: reduce ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('pfc-slider', PfcSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    const syncColumns = () => {
      document.querySelectorAll('[data-pf-col]').forEach((col) => {
        if (mobile.matches) col.removeAttribute('open');
        else col.setAttribute('open', '');
      });
    };

    syncColumns();
    mobile.addEventListener('change', syncColumns);
    document.addEventListener('shopify:section:load', syncColumns);

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-pf-top]')) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pfc-slider')) {
    class PfcSlider extends HTMLElement {
      #track = null;
      #prev = null;
      #next = null;
      #thumb = null;
      #frame = 0;
      #observer = null;
      #onScroll = () => this.#schedule();
      #onPrev = () => this.#go(-1);
      #onNext = () => this.#go(1);

      connectedCallback() {
        this.#track = this.querySelector('[data-pfc-track]');
        if (!this.#track) return;

        this.#prev = this.querySelector('[data-pfc-prev]');
        this.#next = this.querySelector('[data-pfc-next]');
        this.#thumb = this.querySelector('[data-pfc-thumb]');

        this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
        this.#prev?.addEventListener('click', this.#onPrev);
        this.#next?.addEventListener('click', this.#onNext);

        this.#observer = new ResizeObserver(this.#onScroll);
        this.#observer.observe(this.#track);
        this.#update();
      }

      disconnectedCallback() {
        this.#track?.removeEventListener('scroll', this.#onScroll);
        this.#prev?.removeEventListener('click', this.#onPrev);
        this.#next?.removeEventListener('click', this.#onNext);
        this.#observer?.disconnect();
        cancelAnimationFrame(this.#frame);
      }

      #schedule() {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#update());
      }

      #isRtl() {
        return getComputedStyle(this.#track).direction === 'rtl';
      }

      #update() {
        const track = this.#track;
        const max = track.scrollWidth - track.clientWidth;
        const scrollable = max > 2;
        this.toggleAttribute('data-scrollable', scrollable);
        if (!scrollable) return;

        const pos = Math.abs(track.scrollLeft);
        if (this.#prev) this.#prev.disabled = pos <= 2;
        if (this.#next) this.#next.disabled = pos >= max - 2;

        if (!this.#thumb) return;
        const ratio = track.clientWidth / track.scrollWidth;
        const travel = ((1 - ratio) / ratio) * 100;
        const direction = this.#isRtl() ? -1 : 1;
        this.#thumb.style.width = `${ratio * 100}%`;
        this.#thumb.style.transform = `translateX(${(pos / max) * travel * direction}%)`;
      }

      #go(dir) {
        const slide = this.#track.querySelector('[data-pfc-slide]');
        if (!slide) return;

        const gap = parseFloat(getComputedStyle(this.#track).columnGap) || 0;
        const step = slide.getBoundingClientRect().width + gap;
        const perView = Math.max(1, Math.floor((this.#track.clientWidth + gap) / step));
        const direction = this.#isRtl() ? -1 : 1;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.#track.scrollBy({
          left: dir * step * perView * direction,
          behavior: reduce ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('pfc-slider', PfcSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('pdp-delivery')) {
    class PdpDelivery extends HTMLElement {
      connectedCallback() {
        const min = Number(this.dataset.min) || 0;
        const max = Math.max(min, Number(this.dataset.max) || min);
        const skipWeekends = this.dataset.skipWeekends === 'true';
        const out = this.querySelector('[data-pdp-delivery-date]');
        const live = this.querySelector('[data-pdp-delivery-live]');
        const fallback = this.querySelector('[data-pdp-delivery-fallback]');
        if (!out || !live) return;

        const addDays = (days) => {
          const date = new Date();
          let added = 0;
          while (added < days) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (skipWeekends && (day === 0 || day === 6)) continue;
            added += 1;
          }
          return date;
        };

        const lang = document.documentElement.lang || undefined;
        const format = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
        const from = format.format(addDays(min));
        const to = format.format(addDays(max));

        out.textContent = min === max ? from : `${from} – ${to}`;
        live.hidden = false;
        if (fallback) fallback.hidden = true;
      }
    }
    customElements.define('pdp-delivery', PdpDelivery);
  }

  if (!customElements.get('pdp-sticky')) {
    class PdpSticky extends HTMLElement {
      #target = null;
      #priceSource = null;
      #button = null;
      #label = null;
      #price = null;
      #intersection = null;
      #mutation = null;
      #onClick = () => this.#target?.click();
      #sync = () => this.#update();

      connectedCallback() {
        const id = this.dataset.section;
        this.#target = document.getElementById(`ProductSubmitButton-${id}`);
        if (!this.#target) {
          this.hidden = true;
          return;
        }

        this.#priceSource = document.getElementById(`price-${id}`);
        this.#button = this.querySelector('[data-pdp-sticky-btn]');
        this.#label = this.querySelector('[data-pdp-sticky-label]');
        this.#price = this.querySelector('[data-pdp-sticky-price]');

        this.#button?.addEventListener('click', this.#onClick);

        this.#intersection = new IntersectionObserver(([entry]) => {
          this.#toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.#intersection.observe(this.#target);

        this.#mutation = new MutationObserver(this.#sync);
        this.#mutation.observe(this.#target, { attributes: true, childList: true, subtree: true, characterData: true });
        if (this.#priceSource) {
          this.#mutation.observe(this.#priceSource, { childList: true, subtree: true, characterData: true });
        }

        this.#update();
      }

      disconnectedCallback() {
        this.#button?.removeEventListener('click', this.#onClick);
        this.#intersection?.disconnect();
        this.#mutation?.disconnect();
      }

      #toggle(show) {
        this.classList.toggle('is-visible', show);
        this.inert = !show;
        this.setAttribute('aria-hidden', String(!show));
      }

      #update() {
        if (this.#button) {
          this.#button.disabled =
            this.#target.disabled || this.#target.getAttribute('aria-disabled') === 'true';
        }

        const targetLabel = this.#target.querySelector('span');
        if (targetLabel && this.#label) {
          const text = targetLabel.textContent.trim();
          if (text) this.#label.textContent = text;
        }

        const priceRoot = this.#priceSource?.querySelector('.price');
        if (!priceRoot || !this.#price) return;
        const selector = priceRoot.classList.contains('price--on-sale')
          ? '.price__sale .price-item--last'
          : '.price__regular .price-item--regular';
        const priceEl = priceRoot.querySelector(selector);
        if (priceEl) this.#price.textContent = priceEl.textContent.trim();
      }
    }
    customElements.define('pdp-sticky', PdpSticky);
  }

  if (!customElements.get('pdp-gallery')) {
    class PdpGallery extends HTMLElement {
      #track = null;
      #slides = [];
      #thumbs = [];
      #dots = [];
      #prev = null;
      #next = null;
      #current = null;
      #index = 0;
      #frame = 0;
      #resize = null;
      #unsubscribe = null;
      #onScroll = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#sync());
      };
      #onPrev = () => this.goTo(this.#index - 1);
      #onNext = () => this.goTo(this.#index + 1);
      #onThumb = (event) => {
        const thumb = event.target.closest('[data-pdg-thumb]');
        if (thumb) this.goTo(Number(thumb.dataset.pdgThumb));
      };
      #onKey = (event) => {
        if (event.target.closest('input, textarea, select')) return;
        const rtl = this.#isRtl();
        if (event.key === 'ArrowRight') this.goTo(this.#index + (rtl ? -1 : 1));
        if (event.key === 'ArrowLeft') this.goTo(this.#index + (rtl ? 1 : -1));
      };

      connectedCallback() {
        this.#track = this.querySelector('[data-pdg-track]');
        if (!this.#track) return;
        this.#slides = [...this.querySelectorAll('[data-pdg-slide]')];
        this.#thumbs = [...this.querySelectorAll('[data-pdg-thumb]')];
        this.#dots = [...this.querySelectorAll('[data-pdg-dot]')];
        this.#prev = this.querySelector('[data-pdg-prev]');
        this.#next = this.querySelector('[data-pdg-next]');
        this.#current = this.querySelector('[data-pdg-current]');

        this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
        this.#prev?.addEventListener('click', this.#onPrev);
        this.#next?.addEventListener('click', this.#onNext);
        this.querySelector('[data-pdg-thumbs]')?.addEventListener('click', this.#onThumb);
        this.addEventListener('keydown', this.#onKey);

        this.#resize = new ResizeObserver(() => this.goTo(this.#index, false));
        this.#resize.observe(this.#track);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.#unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId && event.data.sectionId !== this.dataset.section) return;
            const mediaId = event?.data?.variant?.featured_media?.id;
            if (!mediaId) return;
            const index = this.#slides.findIndex(
              (slide) => slide.dataset.mediaId === `${this.dataset.section}-${mediaId}`
            );
            if (index > -1) this.goTo(index);
          });
        }

        this.#sync();
      }

      disconnectedCallback() {
        this.#track?.removeEventListener('scroll', this.#onScroll);
        this.#prev?.removeEventListener('click', this.#onPrev);
        this.#next?.removeEventListener('click', this.#onNext);
        this.removeEventListener('keydown', this.#onKey);
        this.#resize?.disconnect();
        if (typeof this.#unsubscribe === 'function') this.#unsubscribe();
        cancelAnimationFrame(this.#frame);
      }

      #isRtl() {
        return getComputedStyle(this.#track).direction === 'rtl';
      }

      goTo(index, smooth = true) {
        if (!this.#track || this.#slides.length === 0) return;
        const clamped = Math.max(0, Math.min(this.#slides.length - 1, index));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const direction = this.#isRtl() ? -1 : 1;
        this.#track.scrollTo({
          left: clamped * this.#track.clientWidth * direction,
          behavior: smooth && !reduce ? 'smooth' : 'auto',
        });
        this.#index = clamped;
        this.#render();
      }

      #sync() {
        const width = this.#track.clientWidth || 1;
        this.#index = Math.round(Math.abs(this.#track.scrollLeft) / width);
        this.#render();
      }

      #render() {
        const i = this.#index;
        const last = this.#slides.length - 1;
        if (this.#prev) this.#prev.disabled = i <= 0;
        if (this.#next) this.#next.disabled = i >= last;
        if (this.#current) this.#current.textContent = String(i + 1);

        for (const [n, dot] of this.#dots.entries()) dot.classList.toggle('is-active', n === i);
        for (const [n, slide] of this.#slides.entries()) {
          if (n === i) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          slide.inert = n !== i;
        }
        for (const [n, thumb] of this.#thumbs.entries()) {
          if (n === i) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        }

        const active = this.#thumbs[i];
        const list = active?.closest('[data-pdg-thumbs]');
        if (!active || !list) return;
        const vertical = list.scrollHeight > list.clientHeight + 2 && list.scrollWidth <= list.clientWidth + 2;
        if (vertical) {
          const top = active.offsetTop - (list.clientHeight - active.offsetHeight) / 2;
          list.scrollTo({ top, behavior: 'smooth' });
        } else {
          const left = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
          list.scrollTo({ left, behavior: 'smooth' });
        }
      }
    }
    customElements.define('pdp-gallery', PdpGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
